import { render, staticRenderFns } from "./FloatButtonsWidget.vue?vue&type=template&id=28dc07e4&scoped=true&"
import script from "./FloatButtonsWidget.vue?vue&type=script&lang=js&"
export * from "./FloatButtonsWidget.vue?vue&type=script&lang=js&"
import style0 from "./FloatButtonsWidget.vue?vue&type=style&index=0&id=28dc07e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dc07e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBadge,VBtn,VIcon,VSheet})
